<style lang="scss" scoped>
.item {
  width: 80vw;
  img {
    height: 300px;
    width: 100%;
    object-fit: cover;
    @media (min-width: 768px) {
      height: 400px;
    }
  }
}
</style>

<template>
  <div class="slider-container" ref="slider">
    <div v-if="$root.isMobile" class="slider">
      <div class="item" v-for="(item, key) in data" :key="key">
        <img class="mb-16" :class="`image-${key}`" :src="deepProperty(key, urlProperty)" />
        <h4 v-if="item[titleProperty]" class="mb-16">{{ item[titleProperty] }}</h4>
        <p v-if="item[descriptionProperty]" class="mb-0 small wordwrap" v-html="item[descriptionProperty]"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';

export default {
  props: {
    data: {
      required: true,
    },
    urlProperty: {
      required: false,
      type: String,
      default: 'urlXXL',
    },
    titleProperty: {
      required: false,
      type: String,
      default: 'title',
    },
    descriptionProperty: {
      required: false,
      type: String,
      default: 'description',
    },
  },
  data() {
    return {
      tns: null,
    };
  },
  methods: {
    init() {
      let self = this;
      this.$nextTick(function() {
        this.tns = tns({
          container: this.$refs.slider.querySelector('.slider'),
          //center: true,
          //edgePadding: 30,
          gutter: 16,
          controls: false,
          touch: true,
          autoWidth: true,
          nav: false,
          loop: false,
          rewind: true,
          preventScrollOnTouch: 'auto',
          items: 1,
        });
      });
    },
    deepProperty(key, s) {
      s = s.split('.');

      var obj = this.data[key][s.shift()];

      while (obj && s.length) obj = obj[s.shift()];

      return obj;
    },
  },
  watch: {
    '$root.isMobile': function(newVal, oldVal) {
      if (newVal && !this.tns) this.init();
    },
  },
};
</script>
